import {
    RESET_DASHBOARD,
    ACA_DASHBOARD_COACH,
    ACA_DASHBOARD_COACH_SUCCESS,
    ACA_DASHBOARD_COACH_ERROR,
    ACA_DASHBOARD_PLAYER,
    ACA_DASHBOARD_PLAYER_SUCCESS,
    ACA_DASHBOARD_PLAYER_ERROR,
    ACA_DASHBOARD_BOWLER,
    ACA_DASHBOARD_BOWLER_SUCCESS,
    ACA_DASHBOARD_BOWLER_ERROR,
    ACA_DASHBOARD_BATWK,
    ACA_DASHBOARD_BATWK_SUCCESS,
    ACA_DASHBOARD_BATWK_ERROR,
    ACA_DASHBOARD_ALLR,
    ACA_DASHBOARD_ALLR_SUCCESS,
    ACA_DASHBOARD_ALLR_ERROR
} from '../constants/ActionTypes';

export const resetDashboard = () => {
    return {
        type: RESET_DASHBOARD,
    };
};

export const acaDashboardCoach = (payload) => {
    return {
        type: ACA_DASHBOARD_COACH,
        payload: payload
    };
};

export const acaDashboardCoachSuccess = (dashboardResponse) => {
    return {
        type: ACA_DASHBOARD_COACH_SUCCESS,
        payload: dashboardResponse
    };
};

export const acaDashboardCoachError = (dashboardResponse) => {
    return {
        type: ACA_DASHBOARD_COACH_ERROR,
        payload: dashboardResponse
    };
};



export const acaDashboardPlayer = (payload) => {
    return {
        type: ACA_DASHBOARD_PLAYER,
        payload: payload
    };
};

export const acaDashboardPlayerSuccess = (dashboardResponse) => {
    return {
        type: ACA_DASHBOARD_PLAYER_SUCCESS,
        payload: dashboardResponse
    };
};

export const acaDashboardPlayerError = (dashboardResponse) => {
    return {
        type: ACA_DASHBOARD_PLAYER_ERROR,
        payload: dashboardResponse
    };
};



export const acaDashboardBowler = (payload) => {
    return {
        type: ACA_DASHBOARD_BOWLER,
        payload: payload
    };
};

export const acaDashboardBowlerSuccess = (dashboardResponse) => {
    return {
        type: ACA_DASHBOARD_BOWLER_SUCCESS,
        payload: dashboardResponse
    };
};

export const acaDashboardBowlerError = (dashboardResponse) => {
    return {
        type: ACA_DASHBOARD_BOWLER_ERROR,
        payload: dashboardResponse
    };
};



export const acaDashboardBatwk = (payload) => {
    return {
        type: ACA_DASHBOARD_BATWK,
        payload: payload
    };
};

export const acaDashboardBatwkSuccess = (dashboardResponse) => {
    return {
        type: ACA_DASHBOARD_BATWK_SUCCESS,
        payload: dashboardResponse
    };
};

export const acaDashboardBatwkError = (dashboardResponse) => {
    return {
        type: ACA_DASHBOARD_BATWK_ERROR,
        payload: dashboardResponse
    };
};



export const acaDashboardAllr = (payload) => {
    return {
        type: ACA_DASHBOARD_ALLR,
        payload: payload
    };
};

export const acaDashboardAllrSuccess = (dashboardResponse) => {
    return {
        type: ACA_DASHBOARD_ALLR_SUCCESS,
        payload: dashboardResponse
    };
};

export const acaDashboardAllrError = (dashboardResponse) => {
    return {
        type: ACA_DASHBOARD_ALLR_ERROR,
        payload: dashboardResponse
    };
};
